module.exports = __webpack_public_path__ + "static/media/shot_200831_115847.ae84ac54.png";